import React, { useEffect, useState, useCallback } from 'react';
import LeadList from '../components/LeadList';
import { fetchLeads, updateLead, deleteLead, addLead } from '../services/api';
import { fetchUsers, addUser } from '../services/userApi';
import { uploadExcelFile } from '../services/dataTransfer';
import '../assets/dashboard.css';

const Dashboard = ({ user }) => {
  const { token, role } = user;
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
 
  const isAdmin = role === 'admin';


  const refreshLeads = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchLeads(token);
      
      setLeads(data);
    } catch (err) {
      setError(err.message || 'Ошибка при загрузке лидов');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    let isMounted = true;
    console.log('Fetching leads with token:', token); 
    const refreshLeads = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchLeads(token);
        console.log('Fetched leads:', data); 
        if (isMounted) {
          setLeads(data);
        }
      } catch (err) {
        console.error('Error fetching leads:', err);
        if (isMounted) {
          setError(err.message || 'Ошибка при загрузке лидов');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    refreshLeads();

    return () => {
      isMounted = false;
    };
    }, [token]);

  const refreshUsers = async () => {
      try {
        const data = await fetchUsers(token);
        setUsers(data);
      } catch (err) {
        console.error('Ошибка при загрузке пользователей:', err);
      }
    };

  useEffect(() => {
      let isMounted = true;

      const refreshAll = async () => {
        setLoading(true);
        try {
          const leadsData = await fetchLeads(token);
          let usersData = [];

          if (isAdmin) {
            usersData = await fetchUsers(token);
          }

          if (isMounted) {
            setLeads(leadsData);
            setUsers(usersData); // Пустой массив для обычных юзеров — норм
          }
        } catch (err) {
          if (isMounted) {
            setError(err.message || 'Ошибка при загрузке данных');
          }
        } finally {
          if (isMounted) setLoading(false);
        }
      };

      refreshAll();

      return () => {
        isMounted = false;
      };
    }, [token, isAdmin]);



  const handleSave = useCallback(async (leadData) => {
    setLoading(true);
    setError(null);
    try {
      await updateLead(token, leadData);
      await refreshUsers();
      await refreshLeads();  
    } catch (err) {
      setError(err.message || 'Ошибка при сохранении лида');
    } finally {
      setLoading(false);
    }
  }, [token, refreshLeads]);

  const handleSaveUser = useCallback(async (userData) => {
  setLoading(true);
  setError(null);
  try {
    await addUser(token, userData);  
    await fetchUsers(token);  
  } catch (err) {
    setError(err.message || 'Ошибка при сохранении пользователя');
  } finally {
    setLoading(false);
  }
}, [token, fetchUsers]);


  const handleDelete = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteLead(token, id);
      await refreshLeads();
    } catch (err) {
      setError(err.message || 'Ошибка при удалении лида');
    } finally {
      setLoading(false);
    }
  }, [token, refreshLeads]);

  const handleAdd = useCallback(async (newLead) => {
    setLoading(true);
    setError(null);
    try {
      await addLead(token, newLead);
      debugger;
      await refreshLeads();
    } catch (err) {
      setError(err.message || 'Ошибка при добавлении лида');
    } finally {
      setLoading(false);
    }
  }, [token, refreshLeads]);
  
const handleExcelUpload = async (file) => {
  console.log('Загрузка файла:', file);
  try {
    console.log('🔐 Token перед отправкой:', token); 
    debugger;
    const result = await uploadExcelFile(token, file);
    alert(`✅ ${result.message}\nAdded: ${result.added}, Пропущено: ${result.skipped}`);

    console.log('Ответ от сервера:', result);
    await refreshLeads();
  } catch (err) {
    console.error('Ошибка загрузки Excel-файла:', err);
  }
};

  return (
    <div className="dashboard-content">
      <h2>Список лидов</h2>

      {loading && <p>Загрузка...</p>}
      {error && <p className="text-danger">{error}</p>}

      <LeadList
        leads={leads}
        users={users}
        role={role}            
        user={user}   
        isAdmin={isAdmin}
        onSave={handleSave}
        onSaveUser={handleSaveUser}
        onDelete={handleDelete}
        onAdd={handleAdd}
        onExcelUpload={handleExcelUpload}
        onRefresh={refreshLeads}
        token={token}
      />
    </div>
  );
};

export default Dashboard;
